export default "__VITE_ASSET__DxtnWTvm__";